import styled from 'styled-components';

import PlayIcon from '../../icons/PlayIcon';

export const Content = styled.div`
  font-size: var(--font-size-md);
  pointer-events: none;
  position: absolute;
  bottom: 5.5rem;
  left: 6rem;
  color: var(--color-text-light);

  @media (${({ theme }) => theme.respondTo.mobile}) {
    display: none;
  }
`;

export const PlaceholderImage = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: -1;

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const PlayButton = styled.div`
  width: 6rem;
  height: 6rem;
  background: var(--color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (${({ theme }) => theme.respondTo.tablet}) {
    width: 10.8rem;
    height: 10.8rem;
  }
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`;

export const StyledPlayIcon = styled(PlayIcon)`
  color: var(--color-primary);

  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 1.8rem;
    height: 2.1rem;
  }
`;

export const Subtitle = styled.span`
  display: block;
`;

export const Title = styled.span`
  font-weight: var(--font-weight-semibold);
  color: var(--color-secondary);
  display: block;
`;

export const VideoWrapper = styled.div`
  overflow: hidden;
  position: relative;
  padding-bottom: 56.25%;
`;
